module.exports = __webpack_public_path__ + "img/Scoops-min.0621cfe6.png";